import {AfterViewInit, ChangeDetectorRef, Component} from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {EbsWebService} from "../../services/ebsWebService";
import {EbsComponentService} from "../../services/ebsComponentService";
import { EbsWebServiceGlobals } from '../../services/ebsWebServiceGlobals';

@Component({
  selector: 'grid-box-component',
  templateUrl: 'grid-box.html',
  inputs: ['gridBoxData']
})
export class GridBoxComponent implements AfterViewInit {

  gridBoxData: any;
  gridBoxDataProcessed: any;
  colorDesign:string = "";

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    public  _ebsComponentService: EbsComponentService, 
    public  _ebsWebService: EbsWebService,
    private cdRef:ChangeDetectorRef,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals ) {
    this.colorDesign = this._ebsWebServiceGlobals.getColorDesign();
  }

  ngAfterViewInit(): void {
    this.gridBoxDataProcessed =  this._ebsWebService.prepareWebServiceDataForView(this.gridBoxData);
    this.cdRef.detectChanges();
  }

  openPage(element) {
    let navParams = {
      title: this.gridBoxData.Caption,
      actionURL: element.Action,
      postParams: element.PostParameters,
      caption: this.gridBoxData.Caption
    };
    this._ebsComponentService.navigationController(element,navParams,this.navCtrl);
  }
}



// WEBPACK FOOTER //
// ./src/components/grid-box/grid-box.ts